module.exports = __webpack_public_path__ + "img/topPhysical.885cd679.svg";